function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15 496h121c8.284 0 15-6.716 15-15v-120c0-8.284-6.716-15-15-15h-121c-8.284 0-15 6.716-15 15v120c0 8.284 6.716 15 15 15zm15-120h91v90h-91z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m316 346h-120c-8.284 0-15 6.716-15 15v120c0 8.284 6.716 15 15 15h120c8.284 0 15-6.716 15-15v-120c0-8.284-6.716-15-15-15zm-15 120h-90v-90h90z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m497 346h-121c-8.284 0-15 6.716-15 15v120c0 8.284 6.716 15 15 15h121c8.284 0 15-6.716 15-15v-120c0-8.284-6.716-15-15-15zm-15 120h-91v-90h91z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m436 316c8.284 0 15-6.716 15-15v-30c0-8.284-6.716-15-15-15h-165v-15c0-8.284-6.716-15-15-15s-15 6.716-15 15v15h-165c-8.284 0-15 6.716-15 15v30c0 8.284 6.716 15 15 15s15-6.716 15-15v-15h150v15c0 8.284 6.716 15 15 15s15-6.716 15-15v-15h150v15c0 8.284 6.716 15 15 15z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301 61c0-24.813-20.187-45-45-45s-45 20.187-45 45 20.187 45 45 45 45-20.187 45-45zm-45 15c-8.271 0-15-6.729-15-15s6.729-15 15-15 15 6.729 15 15-6.729 15-15 15z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181 181c0 8.284 6.716 15 15 15h120c8.284 0 15-6.716 15-15 0-41.355-33.645-75-75-75s-75 33.645-75 75zm75-45c19.556 0 36.239 12.539 42.43 30h-84.86c6.191-17.461 22.874-30 42.43-30z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRole);
export default __webpack_public_path__ + "static/media/role.d1e029fd49625aa35af2c4ff36826285.svg";
export { ForwardRef as ReactComponent };